import { TService } from 'types/service';

import { CRMAPIBase } from '@api/crmApiBase';
import { RequestResult } from '@api/responseModels/requestResult';
import { ServiceListResp } from '@api/responseModels/service/serviceListResponse';
import { ServiceResp } from '@api/responseModels/service/serviceResponse';
import { ServiceModerationLogListResp } from '@api/responseModels/service/serviceModerationLogResponse';

class ServiceAdminGroup extends CRMAPIBase {
    async getAdminBaseServices(
        page = 1,
        categoryId = 1,
        moderateStatus?: string[]
    ): Promise<RequestResult<ServiceListResp>> {
        const result = await this.get<ServiceListResp>('/admin/base-services', {
            page,
            category_id: categoryId,
            ...(moderateStatus?.length ? { filters: { moderate_status: moderateStatus } } : {}),
        });
        return result;
    }

    async getAdminBaseService(id: number): Promise<RequestResult<ServiceListResp>> {
        const result = await this.get<ServiceListResp>(`/admin/base-services/${id}`);
        return result;
    }

    async createAdminBaseService(params: TService): Promise<RequestResult<ServiceListResp>> {
        const result = await this.post<ServiceListResp>(`/admin/base-services/`, params);
        return result;
    }
    async updateAdminBaseService(params: TService): Promise<RequestResult<ServiceResp>> {
        const result = await this.put<ServiceResp>(`/admin/base-services/${params.id}`, params);
        return result;
    }

    async deleteAdminBaseService(params: { id: number }): Promise<RequestResult<ServiceResp>> {
        const result = await this.delete<ServiceResp>(`/admin/base-services/${params.id}`);
        return result;
    }

    async getAdminBaseServiceModerationLogs(
        id: number
    ): Promise<RequestResult<ServiceModerationLogListResp>> {
        const result = await this.get<ServiceModerationLogListResp>(
            `/admin/base-services/${id}/moderation-logs`
        );
        return result;
    }
}
export { ServiceAdminGroup };
